import React, {  } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';


const Footer = (props) => {
    const data = useSelector((state) => state.data.data);

    const getUsername = (url) => {
        const parts = url.split('/');
        for (let i = parts.length - 1; i >= 0; i--) {
            if (parts[i]) {
                return `@${parts[i]}`;
            }
        }
        return '@arghya_mondal'; // default return if no valid username found
    };

    const revealFromBottom = {
        hidden: { opacity: 0, y: 100 },
        visible: { opacity: 1, y: 0 },
    };
    
    return(
        <>
            <div style={{borderTop: "1px solid #303030"}} className='ml-auto flex md:flex-col mr-auto mt-20 pl-5 pr-5 pt-8 pb-5 overflow-y-hidden max-w-5xl'>
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false }}
                    transition={{ duration: 0.5 }}
                    variants={revealFromBottom}
                    className='sm:mb-5' style={{flex: .75}}
                >
                    <p className="font-bold text-3xl">About Me.</p>
                    <p className='text-gray-400 text-sm mt-3 mb-2 pr-2 md:pr-0'>
                        {`/* Arghya Mondal is a versatile Fullstack Developer, who has created impactful solutions like Morvox. He's also a celebrated Hindustani classical flutist on local TV. */`}
                    </p>
                </motion.div>
                <div className="flex-1 flex sm:flex-col">
                    <motion.div 
                        className="flex-1 sm:mb-5"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                        variants={revealFromBottom}
                    >
                        <p className="font-bold text-3xl">Address.</p>
                        <p className='text-gray-400 text-sm mt-3'>
                            Dumdum Cantonment, <br />
                            Kolkata, West Bengal, <br />
                            India, 700065
                        </p>
                    </motion.div>
                    <motion.div 
                        className="sm:mb-5" style={{flex: 1.5}}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false }}
                        transition={{ duration: 0.5, delay: 0.3 }}
                        variants={revealFromBottom}
                    >
                        <p className="font-bold text-3xl">Socials.</p>
                        <p className='text-gray-400 text-sm mt-3'>
                            <span className='font-semibold text-gray-400'>{`>./`}email: </span><Link to={`mailto:${data.meta.social.email}`}>{data.meta.social.email}</Link> <br />
                            <span className='font-semibold text-gray-400'>{`>./`}github: </span><Link to={data.meta.social.github}>{getUsername(data.meta.social.github)}</Link> <br />
                            <span className='font-semibold text-gray-400'>{`>./`}linkedin: </span><Link to={data.meta.social.linkedin}>{getUsername(data.meta.social.linkedin)}</Link> <br />
                            <span className='font-semibold text-gray-400'>{`>./`}instagram: </span><Link to={data.meta.social.instagram}>{getUsername(data.meta.social.instagram)}</Link> <br />
                        </p>
                    </motion.div>
                </div>
            </div>
            <div style={{borderTop: "1px solid #303030"}} className='pt-5 pb-4 flex justify-center items-center'>
                <p className='text-center text-sm sm:text-xs text-gray-500'>&copy; {new Date().getFullYear()} Arghya Mondal. All rights reserved.</p>
            </div>
        </>
    );
}


export default Footer;